import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListRfis extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/site-rfi/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { rfis } = this.props

    const data = rfis.map((rfi, index) => {
      // format date from db
      rfi.created_date = moment(new Date(rfi.created_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${rfi.id}${index}`,
          job: {
            job_id: rfi.job_id,
            job_type: rfi.job_type,
            id: rfi.id
          }
        },
        rfi
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>RFIs</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListRfis



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListRfis.js